import styled, { css } from 'styled-components';
const blockListItemIconStyles = ({ theme }) => css `
	grid-area: icon;
	color: ${theme.colors.base.iconIllustrative};
`;
export const StyledBlockListItemIcon = styled.span `
	${blockListItemIconStyles}
`;
